export default __webpack_public_path__ + "static/media/altumcode.cce9b515.jpg";